import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    const finish = (user) => {
      window.history.replaceState(null, "", "/admin");
      navigate("/admin", { replace: true, state: user ? { user } : undefined });
    };

    if (!sessionId) {
      finish(null);
      return;
    }

    axios
      .post(`${API}/api/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => finish(res.data))
      .catch(() => finish(null));
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#050505]"
    >
      <img
        src="/assets/veritas-seal-192.png"
        alt="Veritas Advisory LLP"
        className="h-16 w-16 animate-pulse rounded-full border border-[#B79045]/40"
      />
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
        Signing you in…
      </p>
    </div>
  );
}
